import axios from 'axios';
import { ApiResponse, OtpResponse } from '../types';

// Create axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for CORS with credentials
});

// Auth services
export const sendOtp = async (email: string): Promise<ApiResponse<OtpResponse>> => {
  try {
    const response = await api.post('/auth/send-otp', { email });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<OtpResponse>;
    }
    throw error;
  }
};

export const verifyOtp = async (email: string, otp: string): Promise<ApiResponse<{ verified: boolean }>> => {
  try {
    const response = await api.post('/auth/verify-otp', { email, otp });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<{ verified: boolean }>;
    }
    throw error;
  }
};

// Form services
export const saveFormData = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await api.post('/form/save', formData);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<any>;
    }
    throw error;
  }
};

export const getFormData = async (email: string): Promise<ApiResponse<any>> => {
  try {
    const response = await api.get(`/form/get/${email}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<any>;
    }
    throw error;
  }
};

// Document upload service
export const uploadDocument = async (file: File, type: string, email: string): Promise<ApiResponse<{ url: string }>> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('email', email);
    
    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<{ url: string }>;
    }
    throw error;
  }
};

// Payment service
export const initiatePayment = async (amount: number, email: string): Promise<ApiResponse<{ orderId: string, keyId: string }>> => {
  try {
    const response = await api.post('/payment/create-order', { amount, email });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<{ orderId: string, keyId: string }>;
    }
    throw error;
  }
};

export const verifyPayment = async (paymentData: any): Promise<ApiResponse<{ success: boolean }>> => {
  try {
    const response = await api.post('/payment/verify', paymentData);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response.data as ApiResponse<{ success: boolean }>;
    }
    throw error;
  }
};

export default api;
